<template>
  <div class="home">
    <!-- 首页 -->
    <div class="wrapper">
      <!-- 顶部搜索 -->
      <div class="searchWrap" >
        <div class="searchInfo" @click="searchStation()">
          <van-icon class="searchIcon" size="" name="search" />
           搜索公交线路/地点
         </div>
        <div class="mapSearch">
          <i class="iconfont icon-weizhi sign" @click="mapSign()"></i>
        </div>
      </div>
      <!-- 是否展示地图区域 -->
      <div id="mapBox" v-if="mapFlag">
      </div>
      <!-- 滚动区域 -->
      <div class="srcollWrap">
        <!-- 站牌信息 附近展开-->
        <div class="BusStation">
          <div class="stationName" @click="stationLineInfo(stationListFirst)">
            <div class="stationTitle">
              <img :src='imgUrl' width="22px" height="22px" class="imgIcon">
              <span class="title">{{stationListFirst.stationName}}</span>
            </div>
          </div>
          <!-- 附件站点展开 -->
          <!-- xxx -->
          <div class="lineInfo" v-for="(line,index) in stationListFirst.stationLineList" :key="index" @click="lineClick(line)">
              <!-- 还剩0站 -->
              <div v-if="line.stationSep == 0">
                <div class="lineTop commonBox">
                      <div class="lineName">{{line.lineName}}</div>
                       <div v-if="line.status == 0" class="lineTime">
                           <span class="unitStyle">下一班次</span>   
                       </div>
                  </div>
                  <div class="lineBottom commonBox">
                    <div class="lineDirection">
                      开往<span class="destination">{{line.lastStationName}}</span>
                    </div>
                   <div class="lineFar">
                          <div v-if="line.status == 0" >
                             <div>预计{{line.departureTime}}发车</div>
                          </div>
                          <div v-if="line.status == 5" class="quickStation">--</div>
                          <div v-if="line.status == 1 || line.status == 2 ||line.status == 3 ||line.status == 4" class="quickStation">即将到站</div>
                    </div>
                </div>
              </div>
              <!-- 大于0站 -->
              <div v-else>
                  <div class="lineTop commonBox">
                      <div class="lineName">{{line.lineName}}</div>
                      <div class="lineTime">
                        <span class="timeNumber">{{line.runTime}}</span><span class="unitStyle">{{line.timeUnit}}</span>
                      </div>
                  </div>
                  <div class="lineBottom commonBox">
                    <div class="lineDirection">
                      开往<span class="destination">{{line.lastStationName}}</span>
                    </div>
                    <div class="lineFar">
                      {{line.stationSep}}站/{{line.distance}}{{line.distanceUnit}}
                    </div>
                </div>
              </div> 
          </div>
          <!-- xxxsd -->
          <div class="watchMore"  @click="stationLineInfo(stationListFirst)" >
            查看更多
          </div>
        </div>
        <!-- 不展开的站牌信息 -->
        <div class="stationWrap">
          <!-- 循环 -->
          <div class="stationBigName" v-for="(item,index) in stationListNoFirst" :key="index" @click="stationLineInfo(item)">
            <div class="stationBigTitle">
              <img :src='imgUrl' width="22px" height="22px" class="imgIcon">
              <span class="BigTitle">{{item.stationName}}</span>
            </div>
            <div class="commonBox">
              <div class="right-arrow">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 标签栏 -->
    <div class="tabBox">
      <van-tabbar v-model="active">
        <van-tabbar-item icon="logistics">出行</van-tabbar-item>
        <van-tabbar-item icon="exchange" @click="goToTramsfer">导乘</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import {setLocalStorage, getLocalStorage} from '@/utils/session.js'
import AMap from 'AMap'
import axios from 'axios'
import { setTimeout } from 'timers';
import { API_DEFAULT_CONFIG } from '@/config/settings.js'
export default {
  name: "home",
  components: {},
  data(){
    return{
      active:0, 
      imgUrl:require('../../../assets/image/station.png'),
      stationList:[],
      stationListFirst:{},
      stationListNoFirst:[],
      centerPositionParams:{},
      flagLength:true,
      lineItemList:[],
      timeList:[],
      latLng:{},
      timer:null,//定时器
      mapFlag:false,//是否展示地图这块
      currentCity:''
    }
  },
  created(){
      let positionArray = window.systemConfig.centerPoint
      this.centerPositionParams = {lng: positionArray[0], lat: positionArray[1]}//默认经纬度
      this.currentCity = window.systemConfig.cityName//默认城市名
  },
   mounted(){
     this.initLocation()
    // this.getDefaultPosition()
     
   },
   beforeRouteLeave(to, from, next){
     console.log('离开首页，清除定时器')
     next()
     clearInterval(this.timer)
     this.timer = null
  },
  methods:{
    //微信配置
    initLocation(){
       const url = window.location.href.split('#')[0]
       this.$api['accesstoken.jsApi']({url: url}).then(res =>{
        if (res) {
          const data = res
          wx.config({
            debug:false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.noncestr,
            signature: data.signature,
            jsApiList: [
              'getLocation',
              'hideMenuItems',
              'hideOptionMenu'
            ]
          })
          this.getLatLng()
        }
      })
    },
    getLatLng(){
      wx.ready(() => { 
        wx.hideMenuItems({
          menuList: ["menuItem:share:qq","menuItem:share:timeline","menuItem:share:appMessage","menuItem:share:weiboApp","menuItem:share:QZone","menuItem:favorite","menuItem:share:facebook","menuItem:copyUrl","menuItem:openWithQQBrowser","menuItem:share:email","menuItem:share:brand","menuItem:editTag","menuItem:delete","menuItem:originPage","menuItem:readMode"]
        })
        wx.hideOptionMenu()
        wx.getLocation({
          type: 'gcj02', 
          success: (res) => {
              let latitude = res.latitude
              let longitude = res.longitude
               AMap.service('AMap.Geocoder',()=>{
                  let  geocoder = new AMap.Geocoder({
                          city: ""//城市，默认：“全国”
                    });
                    let lnglatXY=[longitude, latitude];//地图上所标点的坐标
                     geocoder.getAddress(lnglatXY,(status, result)=> {
                      if (status === 'complete' && result.info === 'OK') {
                            let city = result.regeocode.addressComponent.city;
                            if(city === this.currentCity){
                                const params = {lng: longitude, lat: latitude}
                                this.mapStation(params.lat,params.lng)
                                  setLocalStorage('LatLng', params)
                                  this.timer = setInterval(()=>{
                                      this.mapStation(params.lat,params.lng)
                                  },1000*10)
                            }else{
                              this.getDefaultPosition()
                            }
                      }else{
                          this.getDefaultPosition()
                      }
                    })
                })
              
             },
             fail:(res)=> {
                  this.getDefaultPosition()
             }
          
        })
       
      })
    },

    //默认当前位置是城市中心点
    getDefaultPosition(){
       const params = this.centerPositionParams
       this.mapStation(params.lat,params.lng)
       setLocalStorage('LatLng', params)
        this.timer = setInterval(()=>{
            this.mapStation(params.lat,params.lng)
        },1000*10)
    },
    //首页附近站点查询
    mapStation(lat,lng){
      let  paramasLocation ={
        latitude:lat,
        longitude:lng
      }
      this.$api['station.nearStation'](paramasLocation).then(res => {
        if(res && res.length){
            this.stationListFirst=res[0]
            this.stationListNoFirst= res.slice(1)//除掉第一站
            if(this.stationListFirst.stationLineList.length >3){
              this.stationListFirst.stationLineList =this.stationListFirst.stationLineList.slice(0,3)
              this.flagLength = true
            }else{
              this.flagLength = false
            }
            //处理线路时间
            let arr = []
            this.stationListFirst.stationLineList.forEach(item => {
              arr.push(this.getTwoBusInfo(item))
            })
             Promise.all(arr).then((ele) =>  {
              this.stationListFirst.stationLineList = this.stationListFirst.stationLineList.map((item, index) => {
                return Object.assign({}, item, ele[index])
              })
            })
           
            
          }
        }).catch(err=>{
          
        })
    },
    // 3.4 获取多条线路的最近两辆车辆到站情况
    async  getTwoBusInfo(item){
       let obj = {}
       const stationlineList = [{businessType:item.businessType ,dirctionType:item.dirctionType,lineCode: item.lineCode, lineType: item.lineType, lineStationId: item.lineStationId }]
       let arr = await this.$api['station.timetable'](stationlineList)
       if (arr && arr.length) {
          let lineBus = arr[0].busPosition[0]
          obj = this.handleList(item,lineBus)
          return obj
        }
    },
    //处理线路上的时间和距离
    handleList(line, item){
      const newObj = {
        runTime:  (item.runTime * 1) >= 60 ?  (item.runTime * 1 / 60).toFixed(0)  : item.runTime ,
        timeUnit: (item.runTime * 1) >= 60 ?  "分钟" :'秒',
        distance: (item.distance * 1)>= 1000 ? ((item.distance * 1)/1000).toFixed(1) + '公里': item.distance + '米',
        stationSep: !item.seq ? 0 : (line.seq * 1)- (item.seq * 1),
        status:item.status,
        departureTime:item.departureTime
      }
      return Object.assign({}, newObj)
    },
    //搜索
    searchStation(){
      this.$router.push("/searchPage/index")
    },
    //点击站牌跳转
    stationLineInfo(item){
      this.$router.push({name:"stationDetails",params:{station:item}})
      this.$session.setSession('station',item)
    },
     //地图定位跳转
    mapSign(){
      this.$router.push({name:"stationDetails",params:{station:this.stationListFirst}})
      this.$session.setSession('station',this.stationListFirst)
    },
    //换乘
    goToTramsfer () {
      this.$router.push({name:"transfer"})
    },
    //点击线路跳转
    lineClick(item){
        this.$router.push({name:"lineDetails",params:{line:item,flag:1}})
        this.$session.setSession('line',item)
     }
  }
}
</script>
<style scoped lang="scss">
.home{
  font-size:0.12rem;
  width:100%;
  height:100%;
  overflow:hidden;
  .wrapper{
    background-color: #F8F8F8;
    // width:100%;
    // padding: 0rem 0.2rem;
    height:100%;
    overflow:hidden;
    .searchWrap{
      height: 40px;
      padding: 0.1rem 0px;
      display: flex;
      align-items: center;
      color: #666;
      padding: 0.1rem 0.15rem;
      .searchInfo{
        flex: 1 auto;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        height:40px;
        background-color: #fff;
        border-radius:0.1rem;
        font-size:0.14rem;
        .searchIcon {
          padding-right: 10px;
          font-size:16px
        }
      }
      .mapSearch {
        width: 0.3rem;
        height: 40px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .sign{
           font-size:0.24rem;
        }
      }

    }
    .srcollWrap{
      height: calc(100vh - 2rem);
      overflow: auto;
      padding: 0 0.15rem;
      padding-bottom: 1.5rem;
      margin-bottom: 0.1rem;
      .BusStation{
      background-color: #fff;
      border-radius: 5px;
      padding:0rem 0.15rem;
      //  display: flex;
      align-items: center;
      // box-shadow: 2px 2px 13px 1px #DDE2F7;
      .stationName{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width:100%;
        border-bottom: 1px solid #EEE;
        padding:0.12rem 0rem;
        .stationTitle{
          display: flex;
          align-items: center;
          flex: 1 auto;
          .imgIcon{
            padding-right: 0.1rem;
          }
          .title{
            font-size:14px;
            font-weight:600;
            color:#333;
          }
        }
        .distance{
            display: flex;
            align-items: center;
            font-size:0.12rem;
            color:#333;
            // justify-content: flex-end;
        }
      }
      .lineInfo{
        border-bottom: 1px solid #EEE;
        .lineTop{
          padding:0.1rem 0rem;
          .lineName{
            font-size:0.15rem;
            font-weight:600;
            color:#333;
          }
          .lineTime{
            font-size:0.12rem;
            color: #FF8056;
            .timeNumber{
                font-size:0.20rem;
                font-weight: 600
            }
            .unitStyle{
                font-size:0.14rem;
            }
          }
        }
        .lineBottom{
          padding-bottom:0.1rem;
          .lineDirection{
            color:#666666;
            font-size: 14px;
            .destination{
              padding-left:0.1rem
            }
          }
          .quickStation{
              color:#FF8056;
              font-size: 14px;
           }
          .lineFar{
            color:#546AD9;
            font-size: 14px;
            font-weight: 600;
          }

         
        }
      };
      .watchMore{
        text-align: center;
        font-size:0.13rem;
        color:#666;
        padding:0.1rem 0rem;
      }
    }
    .stationWrap{
      .stationBigName{
        background-color:#fff ;
        border-radius:6px;
        margin-top:0.1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
      //  width:100%;
        border-bottom: 1px solid #EEE;
        padding:0.12rem 0.1rem;
        // box-shadow: 2px 2px 13px 1px #DDE2F7;
        .stationBigTitle{
          display: flex;
          align-items: center;
          flex: 1 auto;
          .imgIcon{
            padding-right: 0.1rem;
          }
          .BigTitle{
            font-size:14px;
            font-weight:600;
            color:#333;
          }
        }
      
        .farMiles{
            display: flex;
            align-items: center;
            font-size:0.12rem;
            color:#333;
          }
          .right-arrow {  
              width: 6px;
              height:6px;
              border-top: 1px solid #333;
              border-right: 1px solid #333;
              transform: rotate(45deg);
              margin-left:0.08rem;
          }
        
      }
    }
    }
  };
  .tabBox{
      width:100%;
      height: 0.4rem;
  }
}
.commonBox{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.marginBox{
  margin-top:0.1rem
}
.titleStyle{

  font-size:0.14rem;
  color:#FF8056
}
.van-tabbar{
  height:66px!important;
}
 
</style>>